import HttpService from "../../constant/Api";

const API = "v1/session";

const API_V2 = "v2/session";

export const getSessionsService = (
  params = { pageNumber: 1, pageSize: 50 }
) => {
  return HttpService.get(`${API}/USER`, { params });
};

export const getSessionsServiceVersion2 = (
  params = { pageNumber: 0, pageSize: 50 }
) => {
  return HttpService.get(`${API_V2}/archive`, { params });
};

export const getSessionDetailService = (sessionId) => {
  return HttpService.get(`${API}/detail/${sessionId}`);
};

export const pinSessionService = (sessionId) => {
  return HttpService.post(`${API_V2}/pin/${sessionId}`);
};

export const unpinSessionService = (sessionId) => {
  return HttpService.post(`${API_V2}/unpin/${sessionId}`);
};
